import {
    AssistantDetailApiV1AssistantAssistantIdGetParams,
    AssistantDTO,
    AssistantFiltersOutputDTO,
    AssistantFreePeriodUserInfoIsAvailable,
    AssistantListApiV1AssistantGetParams,
    AssistantListOutputDTO,
    AssistantSubscription,
    LLMModelAliasOutputDTO,
    LlmModelDetailApiV1AiLlmModelLlmModelSlugGetParams,
    LLMModelDTO,
    LlmModelListApiV1AiLlmModelGetParams,
    LLMModelListOutputDTO,
    LLMModelRestrictedBulkUpsertOutputDTO,
    LLMModelRestrictModel,
    PaidAssistantListForGetUser,
    UserAIDefaultsDTO,
    UserAIDefaultsUpdateModel,
} from '../swagger/dto'
import { deleteRequest, getRequest, patchRequest, postRequest } from './config'
import {
    ASSISTANT_SUBSCRIPTIONS_URL,
    ASSISTANT_URL,
    MODEL_URL,
    TOOL_AI_URL,
    USER_AI_URL,
} from './endpoints.constants'

export const getAssistantList = async (
    params: AssistantListApiV1AssistantGetParams,
): Promise<AssistantListOutputDTO> => {
    const response = await getRequest<void>(ASSISTANT_URL, params)
    return response.data
}

export const patchAssistantById = async (assistantId, data) => {
    const response = await patchRequest<AssistantDTO>(
        `${ASSISTANT_URL}/${assistantId}`,
        data,
    )
    return response.data
}

export const getAssistantDetail = async (
    params: AssistantDetailApiV1AssistantAssistantIdGetParams,
): Promise<AssistantDTO> => {
    const response = await getRequest<AssistantDTO>(`${ASSISTANT_URL}/${params.assistantId}`, {language: params.language})
    return response.data
}

export const getModelList = async (
    params: LlmModelListApiV1AiLlmModelGetParams,
): Promise<LLMModelListOutputDTO> => {
    const response = await getRequest<LLMModelListOutputDTO>(MODEL_URL, params)
    return response.data
}

export const postModel = async (
    data: LLMModelRestrictModel,
): Promise<LLMModelRestrictedBulkUpsertOutputDTO> => {
    const response = await postRequest<
        LLMModelRestrictModel,
        LLMModelRestrictedBulkUpsertOutputDTO
    >(`${MODEL_URL}/restrict`, data)
    return response.data
}

export const getUserAi = async (): Promise<UserAIDefaultsDTO> => {
    const response = await getRequest<UserAIDefaultsDTO>(USER_AI_URL)
    return response.data
}

export const getModelDetail = async (
    params: LlmModelDetailApiV1AiLlmModelLlmModelSlugGetParams,
): Promise<LLMModelDTO> => {
    const response = await getRequest<LLMModelDTO>(`${MODEL_URL}/${params.llmModelSlug}`)
    return response.data
}

export const patchUserAi = async (data: UserAIDefaultsUpdateModel): Promise<UserAIDefaultsDTO> => {
    const response = await patchRequest<UserAIDefaultsDTO>(USER_AI_URL, data)
    return response.data
}

export const getToolDetail = async (data: any): Promise<any> => {
    const response = await getRequest<any>(TOOL_AI_URL, data)
    return response.data
}

export const getAssistantFiltersList = async (): Promise<AssistantFiltersOutputDTO> => {
    const response = await getRequest<AssistantFiltersOutputDTO>(`${ASSISTANT_URL}/filters`)
    return response.data
}

export const getAssistantSubscriptions = async (): Promise<PaidAssistantListForGetUser> => {
    const response = await getRequest<PaidAssistantListForGetUser>(`${ASSISTANT_SUBSCRIPTIONS_URL}`)
    return response.data
}

export const getIsFreeAssistant = async (
    assistant_id,
): Promise<AssistantFreePeriodUserInfoIsAvailable> => {
    const response = await getRequest<AssistantFreePeriodUserInfoIsAvailable>(
        `${ASSISTANT_SUBSCRIPTIONS_URL}/free/${assistant_id}`,
    )
    return response.data
}

export const patchAssistantSubscriptionById = async (
    userSubscriptionId,
): Promise<AssistantSubscription> => {
    const response = await patchRequest<AssistantSubscription>(
        `${ASSISTANT_SUBSCRIPTIONS_URL}/${userSubscriptionId}`,
    )
    return response.data
}

export const postAssistantSubscriptionById = async (
    assistant_id,
): Promise<AssistantSubscription> => {
    const response = await postRequest<AssistantSubscription>(
        `${ASSISTANT_SUBSCRIPTIONS_URL}/${assistant_id}`,
    )
    return response.data
}

export const deleteAssistantSubscriptionById = async (userSubscriptionId) => {
    const response = await deleteRequest<AssistantSubscription>(
        `${ASSISTANT_SUBSCRIPTIONS_URL}/${userSubscriptionId}`,
    )
    return response.data
}
